// src/pages/AdminPage.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../components/Admin/Login';
import UploadPaper from '../components/Admin/UploadPaper';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';

const AdminPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (auth.currentUser) {
      navigate('/admin/upload');
    }
  }, [navigate]);

  return (
    <div className="admin-page">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/upload" element={<UploadPaper />} />
      </Routes>
    </div>
  );
};

export default AdminPage;